import { Brand } from 'apis/enterprise/types';
import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { BrandVenues } from 'modules/enterprise/types';
import { ExperienceEntityTree } from 'modules/experience-core';

export const mapExperienceEntityTreeToBrandVenues = (experienceEntityTree: ExperienceEntityTree): BrandVenues[] => {
  return experienceEntityTree.children.map(experienceBrandEntityNode => {
    return {
      brand: experienceBrandEntityNode.experienceEntity.experienceEntityObject as Brand,
      venues: experienceBrandEntityNode.children.map(
        experienceVenueEntityNode => experienceVenueEntityNode.experienceEntity.experienceEntityObject as Venue,
      ),
    };
  });
};
